import { cn } from '@/lib/cn';
import { RISK_META, type RiskLevel } from '@/config/app';
import { useLanguage } from '@/hooks/useLanguage';

interface StatusBadgeProps {
  level: RiskLevel;
  pulse?: boolean;
  showLabel?: boolean;
  className?: string;
}

export function StatusBadge({ level, pulse, showLabel = true, className }: StatusBadgeProps) {
  const { t } = useLanguage();
  const meta = RISK_META[level];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold',
        'border',
        className,
      )}
      style={{
        backgroundColor: meta.bg,
        color: meta.color,
        borderColor: `${meta.color}30`,
      }}
    >
      <span
        className={cn('w-1.5 h-1.5 rounded-full shrink-0', pulse && 'animate-pulse-dot')}
        style={{ backgroundColor: meta.color }}
      />
      {showLabel && t(meta.label)}
    </span>
  );
}
